import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rValue } from '../../models/.catalog';
import rYurtDisiTasinmazlariGenelBilgi from '../../models/rYurtDisiTasinmazlariGenelBilgi';

export default class YurtDisiTasinmazlariGenelBilgiApi extends ApiBase<
  pList,
  rValue<rYurtDisiTasinmazlariGenelBilgi>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/YurtDisiTasinmazlariGenelBilgi',
      }),
      options
    );
  }
}
